import { render, staticRenderFns } from "./OfferSingleTile.vue?vue&type=template&id=dae99f94&scoped=true&"
import script from "./OfferSingleTile.vue?vue&type=script&lang=js&"
export * from "./OfferSingleTile.vue?vue&type=script&lang=js&"
import style0 from "./OfferSingleTile.vue?vue&type=style&index=0&id=dae99f94&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dae99f94",
  null
  
)

export default component.exports